import React from 'react';

import { CategoryInterface } from '../pages/index.type';

interface CardCategoryPropsInterface {
  category: CategoryInterface;
  onClick: () => void;
}

export default function CardCategory({ category, onClick }: CardCategoryPropsInterface) {
  return (
    <div
      onClick={onClick}
      className="bg-white p-2 rounded-lg w-full flex justify-between mb-3 cursor-pointer">
      <div>
        <div className="text-gray-gray700 laptop:text-extraLarge2 tablet:text-large mobile:text-regular font-interMedium capitalize">
          {category.name}
        </div>
        <div
          className={
            category.products.length > 0
              ? 'flex text-primary-green text-small font-interRegular capitalize'
              : 'flex text-gray-gray700 text-small font-interRegular capitalize'
          }>
          {category.products.length > 0 && (
            <img className="mr-1" src="/images/documentIcon.svg" alt="documentIcon" />
          )}
          {category.products.length} produk dimasukkan
        </div>
      </div>
      <img src="/images/chevronRight.svg" alt="Chevron right icon" />
    </div>
  );
}
